import styled from 'styled-components';
import { theme } from 'styles';
import { Flex } from 'UI';

export const BatteryCard = styled(Flex)<{ padding: number }>`
  padding: ${({ padding }) => padding}px;
  border-radius: 30px;
  border: dashed 2px ${theme.color.grey85};
`;
